
export default {
  name: 'Plus',

  /**
   * Plus - Icon
   * This is an icon is resembles a blue plus sign
   */

  props: {
    width: {
      type: String,
      default: '25px',
    },
    height: {
      type: String,
      default: '25px',
    },
    color: {
      type: String,
      default: '#009FD4',
    },
  },
};
